package com.zq.webproject.utils

import kotlin.js.Date

/**
 * Web/JS平台实现
 */
actual fun getCurrentTimeMillis(): Long {
    return Date.now().toLong()
}
